import Commons from '../../../../../Services/Common/Common';

export const MAI_BASIC_Schema = {
  mapper: {
    search1: {},
  },
};
